export default "__VITE_PUBLIC_ASSET__d447b99a__"